<div class="box">
    <div>
        <div>
            <h1>Your Result Score: <span class="{{gradeClassColor}}">{{score}}</span></h1>
        </div>
        <div>
            <h1 class="text-center {{gradeClassColor}}">{{gradeClassText}}</h1>
        </div>

        <div class="text-center" style="margin-top:20px">
            <button (click)="onRetry()" class="btnx">Try again</button>
        </div>
        <div class="text-center" style="margin-top:10px">
            <button (click)="onSuffleQuestions()" class="btnx">Shuffle Questions</button>
        </div>
        <div class="text-center" style="margin-top:10px">
            <button *ngIf="!isShowResult" (click)="onShowResult()" class="btnx">Show Result</button>
            <button *ngIf="isShowResult" (click)="onShowResult()" class="btnx">Hide Result</button>
        </div>
    </div>

</div>

<div class="row" *ngIf="isShowResult">
    <app-quiz-item [index]="getIndex(i)" [hideAction]="true" [showAnswer]="true" [question]="question" *ngFor="let question of questions;let i = index">

    </app-quiz-item>
</div>

